import { reduxForm } from 'redux-form'
import { FORM_NAME } from './constants'
import ConfirmYourVehicleForm from './ConfirmYourVehicleForm'

export default reduxForm(
  { form: FORM_NAME }
)(ConfirmYourVehicleForm)
